import { createContext, useState } from 'react';

export const CurrentModuleContext = createContext();

export const CurrentModuleProvider = ({ children }) => {
  const [idModule, setIdModule] = useState(null);

  return <CurrentModuleContext.Provider value={{ idModule, setIdModule }}>{children}</CurrentModuleContext.Provider>;
};
